import { render, staticRenderFns } from "./OilPopup.vue?vue&type=template&id=968f2a58&"
import script from "./OilPopup.vue?vue&type=script&lang=js&"
export * from "./OilPopup.vue?vue&type=script&lang=js&"
import style0 from "./OilPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports